"use client"

import FilterChips from "@/app/(site)/_components/Organisms/ProductGrids/Filter/FilterChips"
import FilterItems from "@/app/(site)/_components/Organisms/ProductGrids/Filter/FilterItems"
import { Sort } from "@/app/(site)/_components/Organisms/ProductGrids/Filter/Inputs/Sort"
import {
    useProductGridContext,
    useStaticGridContext
} from "@/app/(site)/contexts/product-grid/ProductGridContext"
export default function FilterPanelContent() {
    const { filterState } = useProductGridContext()
    const { initialFilters, sortSplitIndex, sortOpen, initialOpenFields } =
        useStaticGridContext()

    const filterCount = filterState.filters.reduce((acc, f) => acc + f.data.length, 0)
    const hasAnyActive = filterCount > 0

    const filtersBefore = initialFilters.slice(0, sortSplitIndex)
    const filtersAfter = initialFilters.slice(sortSplitIndex)

    return (
        <>
            {hasAnyActive && (
                <div className="flex shrink-0 flex-wrap gap-12 px-12 py-24 lg:px-24 lg:pb-24 lg:pt-0">
                    <FilterChips />
                </div>
            )}
            <div className="flex-1 overflow-y-auto overflow-x-hidden overscroll-contain [scrollbar-gutter:stable] lg:thin-scrollbar">
                {filtersBefore.map((filter, index) => (
                    <FilterItems
                        key={`${filter.field}-${index}`}
                        filter={filter}
                        initialOpen={initialOpenFields.includes(filter.field)}
                    />
                ))}
                <Sort initialOpen={sortOpen} />
                {filtersAfter.map((filter, index) => (
                    <FilterItems
                        key={`${filter.field}-${sortSplitIndex + index}`}
                        filter={filter}
                        initialOpen={initialOpenFields.includes(filter.field)}
                    />
                ))}
            </div>
        </>
    )
}
